import React from "react"
import { EAppView } from "../../Enum/EAppViewType"
import { useTranslation } from "react-i18next"
import Animate, { AnimationTypes } from "../../components/Animate/Animate"
import { companyMemory } from "../../Objects/Memory/Memory"
import { getPublicMenuTheme, isLegacyPublicMenuTheme } from "../Helpers/PublicMenuTheme"

interface LoginRedirectViewProps {
  title?: string
  description?: string
  setCurrentView: (view: EAppView) => void
}

export const LoginRedirectView: React.FC<LoginRedirectViewProps> = ({ title, description, setCurrentView }) => {
  const { t } = useTranslation()

  const resolvedTitle = title ?? t("publicMenu:redirect.restricted_access")

  const resolvedDescription = description ?? t("publicMenu:redirect.login_to_continue")

  const theme = getPublicMenuTheme(companyMemory)

  const isLegacyTheme = isLegacyPublicMenuTheme(theme)

  return (
    <Animate type={AnimationTypes.fadeInTraslate}>
      <div className="max-w-xl mx-auto py-24 text-center space-y-6 animate-in fade-in duration-500">
        <div
          className="w-24 h-24 bg-orange-50 rounded-full flex items-center justify-center mx-auto text-orange-500 text-4xl shadow-inner"
          style={
            isLegacyTheme ? undefined : { backgroundColor: theme.secondaryColor, color: theme.accentColor }
          }
        >
          🔒
        </div>

        <h2
          className="text-2xl font-black text-gray-900 tracking-tight"
          style={isLegacyTheme ? undefined : { color: theme.emptyStateTitleColor }}
        >
          {resolvedTitle}
        </h2>

        <p
          className="text-gray-500 max-w-sm mx-auto"
          style={isLegacyTheme ? undefined : { color: theme.emptyStateDescriptionColor }}
        >
          {resolvedDescription}
        </p>

        <button
          onClick={() => setCurrentView(EAppView.LoginView)}
          style={
            isLegacyTheme
              ? undefined
              : {
                  backgroundColor: theme.loginButtonBackgroundColor,
                  color: theme.loginButtonTextColor,
                  boxShadow: `0 0 0 2px ${theme.loginButtonTextColor}`,
                }
          }
          className="max-w-xl mx-auto h-14 px-6 ring-2 ring-orange-400 text-black rounded-[0.5rem] font-black text-[14px] uppercase tracking-[0.05em] shadow-2xl active:scale-95 transition-all flex items-center justify-center gap-3"
          data-interaction-description-key="interactionDescriptions:publicMenu.components.loginRedirectView.button.setCurrentViewEAppViewLoginView"
        >
          <span>{t("publicMenu:redirect.go_to_login")}</span>

          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>
      </div>
    </Animate>
  )
}
